import { render } from "./CopyCode.vue?vue&type=template&id=076a72f3&scoped=true"
import script from "./CopyCode.vue?vue&type=script&lang=js"
export * from "./CopyCode.vue?vue&type=script&lang=js"

import "./CopyCode.vue?vue&type=style&index=0&id=076a72f3&lang=scss&scoped=true"

import exportComponent from "../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-076a72f3"]])

export default __exports__